import AttachmentPreviews from './AttachmentPreviews';

export default AttachmentPreviews;
